import { LayoutModel } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

import { getSchemaForProjectHierarchyModel } from './getSchemaForProjectHierarchyModel';

export function validateProjectHierarchyModelHasRequiredProperties(layoutModel: LayoutModel) {
  const schema = getSchemaForProjectHierarchyModel(layoutModel);
  const missingRequiredProperties = [];
  for (const propertyName of Object.keys(schema.properties)) {
    if (schema.properties[propertyName as keyof LayoutModel]!.configuration.required) {
      const value = layoutModel[propertyName as keyof LayoutModel];
      if (value === null || value === '') {
        missingRequiredProperties.push(propertyName);
      }
    }
  }

  if (missingRequiredProperties.length > 0) {
    return `Missing ${humanCase(layoutModel.type).toLowerCase()} properties on ${
      layoutModel.name ?? humanCase(layoutModel.type)
    }: ${missingRequiredProperties.map(humanCase).join(', ')}`;
  }

  return '';
}
